import React, { Fragment, useState, useEffect, useRef } from "react";
import { Form, Row, Col, Input, Button, message } from 'antd';
import { saveStudentInfo, getQuizName } from 'lib'
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import TranslatedText from "translations/TranslatedText";
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import PreloadedImage from 'ReusableComponents/PreloadedImage';

export default function SubmitEmail(props) {
  const {
    onSubmit,
  } = props;
  const [name, setName] = useState('');
  // 1 instead of true fixes bug whereby useEffect can detect a change
  const [nameValid, setNameValid] = useState(1);
  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(1);
  const quizName = getQuizName();

  const validateEmail = () => {
    if (isEmail(email)) {
      setEmailValid(true)
    } else {
      setEmailValid(false)
    }

    if (!isEmpty(name)) {
      setNameValid(true)
    } else {
      setNameValid(false)
    }
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      if (!isEmpty(email) && !isEmpty(name) && emailValid && nameValid) {
        saveStudentInfo(name, email);
        onSubmit();
      }
    }
    return () => { isMounted = false }; // prevent state changes after unmount
  }, [emailValid, nameValid])

  return (
    <Row style={{ height: '100vh' }} type="flex" justify="center">
      <Col>
        <Row type="flex" justify="center" align="middle">
          <Col>
            <PreloadedImage image="logo" />
          </Col>
        </Row>
        <Row type="flex" justify="center" align="middle">
          <Col>
            {
              quizName === "China Quiz" ?
              <PreloadedImage image="email_logo" /> :
              <Title>{quizName}</Title>
            }
          </Col>
        </Row>
        <Form>
          <Input.Group>
            <Row type="flex" justify="center" align="middle">
              <Col>
                <Title level={4}><TranslatedText id="student.form.submitemail.label" /></Title>
              </Col>
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Col span={10}>
                <Form.Item validateStatus={nameValid ? "success" : "error"}>
                  <Input addonBefore="name" placeholder="john doe"
                         onChange={(event) => setName(event.target.value)}
                         value={name}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Col span={10}>
                <Form.Item validateStatus={emailValid ? "success" : "error"}>
                  <Input.Search placeholder="john.doe@gmail.com"
                          addonBefore="email"
                          onPressEnter={validateEmail}
                          onChange={(event) => setEmail(event.target.value)}
                          value={email}
                          enterButton="Submit"
                          onSearch={validateEmail}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ maxHeight: 0 }} type="flex" justify="center" align="middle">
              <Col span={12}>
                <Paragraph style={{ lineHeight: '3em' }}><em>
                  <TranslatedText id="student.form.submitemail.instructions" />
                </em></Paragraph>
                <Paragraph style={{ lineHeight: '3em' }}><em>
                  <TranslatedText id="student.form.submitemail.instructions2" />
                </em></Paragraph>
              </Col>
            </Row>
          </Input.Group>
        </Form>
      </Col>
    </Row>
  );
} 
